import { render, staticRenderFns } from "./clAdvantages.vue?vue&type=template&id=54e884a5&scoped=true"
import script from "./clAdvantages.vue?vue&type=script&lang=js"
export * from "./clAdvantages.vue?vue&type=script&lang=js"
import style0 from "./clAdvantages.vue?vue&type=style&index=0&id=54e884a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e884a5",
  null
  
)

export default component.exports